import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
import Vue from 'vue';
import ElementUI from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';

console.log('Store actions:', Object.keys(store._actions));
if (!store._actions['fetchUsers']) {
  console.error('CRITICAL: fetchUsers action missing from store!');
}
import i18n from './i18n';
import './styles/global.scss';

// 创建事件总线，用于组件间通信
Vue.prototype.$eventBus = new Vue();

Vue.use(ElementUI);

// 全局mixin：缓存列表页面在activated时自动刷新数据
// 解决新增/编辑数据返回列表页后数据不刷新的问题
Vue.mixin({
  data() {
    return {
      listAutoRefreshInitialized: false
    }
  },
  activated() {
    // 首次激活跳过（数据已在created中加载）
    if (!this.listAutoRefreshInitialized) {
      this.listAutoRefreshInitialized = true
      return
    }
    // 后续激活时自动刷新列表数据（仅对keep-alive缓存且含数据加载方法的组件生效）
    const refreshFn = this.fetchData || this.loadData || this.getList
    if (typeof refreshFn === 'function') {
      refreshFn.call(this)
    }
  }
})

Vue.config.productionTip = false

// 创建Vue实例
new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')